export const fileSizeLimits = {
  video: 104857600, //100 mb
  image: 15000000,
};
